import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Salon Owner',
    image: '/placeholder-avatar-1.jpg',
    content: 'LocalFlow has completely transformed how I manage my salon. The automated booking system alone has saved me hours each week.',
    rating: 5
  },
  {
    name: 'Mike Chen',
    role: 'Restaurant Manager',
    image: '/placeholder-avatar-2.jpg',
    content: 'The customer service automation is incredible. Our response time has improved dramatically, and our customers love it.',
    rating: 5
  },
  {
    name: 'Emily Rodriguez',
    role: 'Fitness Studio Owner',
    image: '/placeholder-avatar-3.jpg',
    content: 'The insights and analytics have helped us make better business decisions. We have increased our revenue by 30% since using LocalFlow.',
    rating: 5
  }
];

const Testimonials = () => {
  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Loved by Local Businesses
          </h2>
          <p className="text-xl text-gray-600">
            See what our customers have to say about LocalFlow
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              className="bg-white p-6 rounded-xl shadow-sm"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-600 mb-6">{testimonial.content}</p>
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="h-12 w-12 rounded-full"
                />
                <div className="ml-3">
                  <h4 className="font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
